import axios, { AxiosRequestConfig } from "axios";
import {
  CreateClienteData,
  CreateSellerData,
  EditClienteData,
} from "../types/clientData";
import { VehicleData } from "../types/vehicleData";

export const getClients = async (token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cliente`;

    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar clientes:", error);
    throw error;
  }
};

export const fetchClientByDocumentApiConfig = async (
  documento: string,
  token: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cliente/busca/api?documento=${documento}`;
    const response = await axios.get(url, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar cliente via ApiConfig:", error);
    throw error;
  }
};

export const getClientsCompany = async (token: string, companyId: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cliente?id_empresa=${companyId}`;

    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar clientes da empresa:", error);
    throw error;
  }
};

export const createClient = async (
  token: string,
  clientData: CreateClienteData
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cliente`;
    const response = await axios.post(url, clientData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar cliente:", error);
    throw error;
  }
};

export const getClientById = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cliente/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar detalhes do client:", error);
    throw error;
  }
};

export const unlinkClientFromVehicle = async (
  token: string,
  idVeiculo: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/desvincula/${idVeiculo}`;
    const response = await axios.post(url, {}, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao desvincular cliente:", error);
    throw error;
  }
};

export const updateClient = async (
  token: string,
  id: string,
  clientData: Partial<CreateClienteData>
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cliente/${id}`;
    const response = await axios.put(url, clientData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar cliente:", error);
    throw error;
  }
};

export const createClientWithVehicle = async (
  data: EditClienteData,
  token: string,
  vehicleId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/veiculo/${vehicleId}/cliente`;
    const response = await axios.post(url, data, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao criar cliente:", error);
    throw error;
  }
};

export const createSellerWithVehicle = async (
  data: CreateSellerData,
  token: string,
  vehicleId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/vendedor/${vehicleId}`;
    const response = await axios.post(url, data, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao criar vendedor:", error);
    throw error;
  }
};

export const getNotificationsClient = async (token: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/count/notificacao`;

    const response = await axios.get(url, config);
    return response.data.totalNotificacao;
  } catch (error) {
    console.error("Erro ao buscar notificações:", error);
    throw error;
  }
};

export const createClientLinkVehicle = async (
  data: VehicleData,
  token: string,
  clientId: string
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cliente/${clientId}/${data.id}`;

    const response = await axios.put(url, data, config);

    return response.data;
  } catch (error) {
    console.error("Erro ao vincular veículo ao cliente:", error);
    throw error;
  }
};

export const fetchClientByDocument = async (
  documento: string,
  token: string
) => {
  try {
    const url = `${process.env.REACT_APP_API_DOMAIN}/entrega/cliente/find/${documento}`;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar cliente pelo documento:", error);
    throw error;
  }
};
